<template>
  <cs-view single-view>
    <template #content>
      <div v-if="!isOnStbIframe" class="mx-0 my-4">
        <v-row class="ma-0" align="end" justify="end">
          <v-col cols="2">
            <v-select
              :model-value="stbEnvironment"
              :items="supportedStbEnvironments"
              testing-id="stb-environment-select"
              variant="solo"
              density="compact"
              color="primary"
              label="STB Environment"
              hide-details
              :disabled="isReadyToCreateExcursion"
              @update:model-value="changeStbEnvironment"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="oauthSignature"
              testing-id="oauth-signature-input"
              variant="solo"
              density="compact"
              color="primary"
              label="OAuth Signature"
              hide-details
              :disabled="isReadyToCreateExcursion"
            />
          </v-col>
          <v-col cols="6">
            <v-select
              :model-value="studentVendor"
              :items="studentVendorList"
              testing-id="student-vendor-select"
              variant="solo"
              density="compact"
              color="primary"
              label="Select Student Vendor"
              hide-details
              :disabled="isReadyToCreateExcursion"
              @update:model-value="changeStudentVendor"
            ></v-select>
          </v-col>
          <v-col cols="1" class="mb-1">
            <cs-button
              testing-id="confirm-btn"
              primary
              label="Confirm"
              :disabled="isReadyToCreateExcursion"
              @click="testOauthSignature"
            />
          </v-col>
        </v-row>
        <v-row v-if="isReadyToCreateExcursion" class="ma-0">
          <v-col cols="12" align="center" justify="center">
            <span>PCG Next Gen Prototype</span>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="excursionName"
              testing-id="excursion-name-input"
              variant="solo"
              density="compact"
              color="primary"
              label="Excursion Name"
            />
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="excursionType"
              testing-id="excursion-type-select"
              :items="availableExcursionTypes"
              variant="solo"
              density="compact"
              color="primary"
              label="Excursion Type"
            />
          </v-col>
          <v-col cols="6">
            <v-menu
              v-model="showExcursionStartDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              location="bottom"
              min-width="auto"
            >
              <template #activator="{ props }">
                <v-text-field
                  v-bind="props"
                  id="date-selector-text-field"
                  v-model="formattedExcursionStartDate"
                  testing-id="excursion-start-date-input"
                  label="Excursion Start Date"
                  readonly
                  density="compact"
                  variant="solo"
                  color="primary"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="excursionStartDate"
                testing-id="excursion-start-date-picker"
                hide-header
                color="primary"
              >
                <template #actions>
                  <cs-button
                    id="date-selector-date-picker-cancel"
                    testing-id="excursion-start-date-picker-cancel"
                    label="Cancel"
                    @click="cancelUpdateExcursionStartDate()"
                  ></cs-button>
                  <cs-button
                    id="date-selector-date-picker-ok"
                    testing-id="excursion-start-date-picker-ok"
                    primary
                    label="OK"
                    @click="showExcursionStartDateMenu = false"
                  ></cs-button>
                </template>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <v-menu
              v-model="showExcursionEndDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              location="bottom"
              min-width="auto"
            >
              <template #activator="{ props }">
                <v-text-field
                  v-bind="props"
                  v-model="formattedExcursionEndDate"
                  testing-id="excursion-end-date-input"
                  label="Excursion End Date"
                  readonly
                  density="compact"
                  variant="solo"
                  color="primary"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="excursionEndDate"
                testing-id="excursion-end-date-picker"
                hide-header
                color="primary"
              >
                <template #actions>
                  <cs-button
                    id="date-selector-date-picker-cancel"
                    testing-id="excursion-end-date-picker-cancel"
                    label="Cancel"
                    @click="cancelUpdateExcursionEndDate()"
                  ></cs-button>
                  <cs-button
                    id="date-selector-date-picker-ok"
                    testing-id="excursion-end-date-picker-ok"
                    primary
                    label="OK"
                    @click="showExcursionEndDateMenu = false"
                  ></cs-button>
                </template>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row v-if="!isNewExcursion">
          <v-col cols="12" align="center" justify="center">
            <span>Destination</span>
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="excursionJurisdiction"
              :items="jurisdiction"
              testing-id="excursion-jurisdiction-select"
              variant="solo"
              density="compact"
              color="primary"
              label="Excursion Destination"
              clearable
            />
          </v-col>
          <v-col cols="12" align="center" justify="center">
            <span>Risk Categories</span>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="excursionStaffCount"
              testing-id="excursion-staff-count-input"
              variant="solo"
              density="compact"
              color="primary"
              label="Number of Staff Attending"
            />
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="excursionStudentCount"
              testing-id="excursion-student-count-input"
              variant="solo"
              density="compact"
              color="primary"
              label="Number of Students Attending"
            />
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="excursionTransports"
              :items="availableExcursionTransports"
              testing-id="excursion-transports-select"
              variant="solo"
              density="compact"
              color="primary"
              label="Transports"
              multiple
              chips
            />
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="excursionVenues"
              :items="availableExcursionVenues"
              testing-id="excursion-venues-select"
              variant="solo"
              density="compact"
              color="primary"
              label="Venues"
              multiple
              chips
            />
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="excursionFoods"
              :items="availableExcursionFoods"
              testing-id="excursion-foods-select"
              variant="solo"
              density="compact"
              color="primary"
              label="Foods"
              multiple
              chips
            />
          </v-col>
          <v-col cols="6">
            <v-select
              v-model="excursionActivities"
              :items="availableExcursionActivities"
              testing-id="excursion-activities-select"
              variant="solo"
              density="compact"
              color="primary"
              label="Activities"
              multiple
              chips
            />
          </v-col>
          <v-col v-if="showAvailableAccommodations" cols="6">
            <v-select
              v-model="excursionAccommodations"
              :items="availableExcursionAccommodations"
              testing-id="excursion-accommodations-select"
              variant="solo"
              density="compact"
              color="primary"
              label="Accommodations"
              multiple
              chips
            />
          </v-col>
        </v-row>
        <v-row v-if="isReadyToCreateExcursion" align="end" justify="end" class="mr-0">
          <cs-button
            testing-id="restart-excursion-btn"
            class="mx-2"
            secondary
            label="Restart"
            @click="restartExcursion"
          />
          <div v-if="isNewExcursion">
            <cs-button
              testing-id="create-excursion-btn"
              primary
              :disabled="!canCreateExcursion"
              label="Create Excursion"
              @click="createExcursion"
            />
          </div>
          <div v-else>
            <cs-button
              testing-id="complete-risk-assessment-btn"
              class="mx-2"
              label="Complete Risk Assessment"
              @click="onCompleteRiskAssessmentClicked"
            />
            <cs-button
              testing-id="sync-excursion-btn"
              primary
              label="Sync Excursion"
              @click="syncExcursion"
            />
          </div>
        </v-row>
      </div>
      <div v-else class="stb-risk-assessment-container">
        <cs-button
          testing-id="close-risk-assessment-btn"
          class="ma-2"
          primary
          label="Close Risk Assessment"
          @click="isOnStbIframe = false"
        ></cs-button>
        <iframe
          id="stbRiskAssessmentContainer"
          testing-id="stb-risk-assessment-iframe"
          :src="stbRiskAssessmentUrl"
        ></iframe>
      </div>
    </template>
  </cs-view>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import * as types from '../store/mutationTypes';
import { CSBase } from '@complispace/cs-design-system';
import moment from 'moment-timezone';
import axios from 'axios';

export default {
  name: 'PcgNextGenPrototype',
  extends: CSBase,
  data() {
    return {
      axiosInstanceForStbApi: null,
      excursionName: '',
      excursionType: '',
      excursionStartDate: '',
      excursionEndDate: '',
      excursionStaffCount: 0,
      excursionStudentCount: 0,
      excursionTransports: [],
      excursionVenues: [],
      excursionFoods: [],
      excursionActivities: [],
      excursionAccommodations: [],
      excursionJurisdiction: '',
      showExcursionStartDateMenu: false,
      showExcursionEndDateMenu: false,
      isNewExcursion: true,
      paramsForStbApi: {
        'user-email': 'any-user-email@ideagen.com',
        'excursion-id': '0',
        'vendor-sid': '10000415',
        'vendor-client-sid': 'pcg-next-gen-prototype-with-operoo',
        'vendor-excursion-sid': '100'
      },
      isOnStbIframe: false,
      studentVendor: 'operoo',
      oauthSignature: '',
      isReadyToCreateExcursion: false,
      studentVendorList: [
        {
          title: 'Operoo (pcg-next-gen-prototype-with-operoo)',
          value: 'operoo'
        },
        {
          title: 'Wonde (pcg-next-gen-prototype-with-wonde)',
          value: 'wonde'
        },
        {
          title: 'TASS (pcg-next-gen-prototype-with-tass)',
          value: 'tass'
        },
        {
          title: 'Complispace (pcg-next-gen-prototype-with-complispace)',
          value: 'complispace'
        },
        {
          title: 'Sentral Api (pcg-next-gen-prototype-with-sentral-api)',
          value: 'sentral-api'
        }
      ],
      jurisdiction: ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'],
      supportedStbEnvironments: ['dev', 'staging'],
      stbEnvironment: 'dev',
      clientSids: {
        'pcg-next-gen-prototype-with-operoo': {
          dev: '10000420',
          staging: '10000487'
        },
        'pcg-next-gen-prototype-with-wonde': {
          dev: '10000421',
          staging: '10000488'
        },
        'pcg-next-gen-prototype-with-tass': {
          dev: '10000423',
          staging: '10000490'
        },
        'pcg-next-gen-prototype-with-complispace': {
          dev: '10000422',
          staging: '10000489'
        },
        'pcg-next-gen-prototype-with-sentral-api': {
          dev: '10000508',
          staging: '10000886'
        }
      },
      selectedClientSid: null
    };
  },
  computed: {
    ...mapState({
      availableExcursionTypes: (state) => state['stb-excursions'].types,
      availableExcursionTransports: (state) => state['stb-excursions'].riskCategories.transports,
      availableExcursionVenues: (state) => state['stb-excursions'].riskCategories.venues,
      availableExcursionFoods: (state) => state['stb-excursions'].riskCategories.foods,
      availableExcursionActivities: (state) => state['stb-excursions'].riskCategories.activities,
      availableExcursionAccommodations: (state) =>
        state['stb-excursions'].riskCategories.accommodations,
      excursionId: (state) => state['stb-excursions'].id
    }),
    formattedExcursionStartDate() {
      return this.excursionStartDate ? moment(this.excursionStartDate).format('YYYY-MM-DD') : '';
    },
    formattedExcursionEndDate() {
      return this.excursionEndDate ? moment(this.excursionEndDate).format('YYYY-MM-DD') : '';
    },
    showAvailableAccommodations() {
      return this.excursionType !== 'Day Excursion';
    },
    canCreateExcursion() {
      return (
        this.excursionName && this.excursionType && this.excursionStartDate && this.excursionEndDate
      );
    },
    stbRiskAssessmentUrl() {
      const queryParams = {
        ...this.paramsForStbApi,
        referrer: 'pcg-nextgen',
        'oauth-signature': this.oauthSignature
      };

      const environmentSuffix = this.stbEnvironment === 'dev' ? '-dev' : '-staging';
      const riskAssessmentUrl = new URL(
        `https://${this.paramsForStbApi['vendor-client-sid']}.app${environmentSuffix}.safetripbuilder.com/excursions/${this.excursionId}`
      );
      Object.keys(queryParams).forEach((key) =>
        riskAssessmentUrl.searchParams.append(key, queryParams[key])
      );
      return riskAssessmentUrl.toString();
    }
  },
  watch: {
    excursionStaffCount(newValue) {
      if (isNaN(newValue)) {
        this.excursionStaffCount = 0;
      }
    },
    excursionStudentCount(newValue) {
      if (isNaN(newValue)) {
        this.excursionStudentCount = 0;
      }
    },
    async excursionType(newValue) {
      const filterBy = newValue !== 'Day Excursion' ? 'accommodations' : null;
      if (newValue === 'Day Excursion') {
        this.excursionAccommodations = [];
      }
      if (!this.isNewExcursion) {
        await this.fetchRiskCategories(filterBy);
      }
    },
    excursionId(newValue) {
      this.paramsForStbApi['excursion-id'] = newValue;
      this.axiosInstanceForStbApi.defaults.params = this.paramsForStbApi;
    },
    async isReadyToCreateExcursion(newValue) {
      if (newValue) {
        await this.$store.dispatch('stb-excursions/fetchExcursionTypes', {
          oauthSignature: this.oauthSignature,
          clientSid: this.selectedClientSid
        });
      }
    }
  },
  async mounted() {
    this.setPageViewType('pcg-next-gen-prototype');
    this.axiosInstanceForStbApi = axios.create({
      baseURL: 'https://api-dev.safetripbuilder.com/',
      params: this.paramsForStbApi
    });
    this.setStbExcursionAxios(this.axiosInstanceForStbApi);
    this.selectedClientSid =
      this.clientSids['pcg-next-gen-prototype-with-operoo'][this.stbEnvironment];
  },
  methods: {
    ...mapMutations({
      setPageViewType: types.VIEW_TYPE_SET_PAGE_VIEW_TYPE,
      setStbExcursionAxios: types.STB_EXCURSION_SET_AXIOS,
      resetStbExcursionState: types.STB_EXCURSION_RESET_EXCURSION
    }),
    cancelUpdateExcursionStartDate() {
      this.showExcursionStartDateMenu = false;
      this.excursionStartDate = '';
    },
    cancelUpdateExcursionEndDate() {
      this.showExcursionEndDateMenu = false;
      this.excursionEndDate = '';
    },
    async createExcursion() {
      try {
        this.oauthSignature = await this.$store.dispatch('stb-excursions/createExcursion', {
          name: this.excursionName,
          type: this.excursionType,
          startDate: this.formattedExcursionStartDate,
          endDate: this.formattedExcursionEndDate,
          oauthSignature: this.oauthSignature
        });
        this.showSuccessAlert(`Excursion with ID ${this.excursionId} created successfully`);
        this.isNewExcursion = false;
        await this.fetchRiskCategories();
      } catch (error) {
        this.showErrorAlert(error.message);
      }
    },
    async syncExcursion() {
      const excursionData = {
        name: this.excursionName,
        type: this.excursionType,
        startDate: this.formattedExcursionStartDate,
        endDate: this.formattedExcursionEndDate,
        staffCount: this.excursionStaffCount,
        studentCount: this.excursionStudentCount,
        riskCategories: {
          transports: this.excursionTransports,
          venues: this.excursionVenues,
          foods: this.excursionFoods,
          activities: this.excursionActivities,
          accommodations: this.excursionAccommodations
        },
        jurisdiction: this.excursionJurisdiction
      };
      try {
        const result = await this.$store.dispatch('stb-excursions/syncExcursion', {
          id: this.excursionId,
          excursionData,
          oauthSignature: this.oauthSignature
        });

        if (result.warningMessage) {
          const warningMessage = result.warningMessage;
          return this.showWarningAlert(
            `Excursion with ID ${this.excursionId} synced successfully with ${warningMessage.code} warning: ${warningMessage.message}`
          );
        }

        this.showSuccessAlert(`Excursion with ID ${this.excursionId} synced successfully`);
      } catch (error) {
        this.showErrorAlert(error.message);
      }
    },
    async restartExcursion() {
      this.resetStbExcursionState();
      this.isReadyToCreateExcursion = false;
      this.oauthSignature = '';
      this.excursionName = '';
      this.excursionType = '';
      this.excursionStartDate = '';
      this.excursionEndDate = '';
      this.excursionStaffCount = 0;
      this.excursionStudentCount = 0;
      this.excursionTransports = [];
      this.excursionVenues = [];
      this.excursionFoods = [];
      this.excursionActivities = [];
      this.excursionAccommodations = [];
      this.excursionJurisdiction = '';
      this.isNewExcursion = true;
    },
    async fetchRiskCategories(filterBy) {
      try {
        await this.$store.dispatch('stb-excursions/fetchRiskCategories', {
          excursionType: this.excursionType,
          filterBy,
          oauthSignature: this.oauthSignature,
          clientSid: this.selectedClientSid
        });
      } catch (error) {
        this.showErrorAlert(`Failed to fetch risk categories. Error: ${error.message}`);
      }
    },
    changeStudentVendor(studentVendor) {
      this.studentVendor = studentVendor;
      switch (studentVendor) {
        case 'operoo':
          this.paramsForStbApi['vendor-client-sid'] = 'pcg-next-gen-prototype-with-operoo';
          break;
        case 'wonde':
          this.paramsForStbApi['vendor-client-sid'] = 'pcg-next-gen-prototype-with-wonde';
          break;
        case 'tass':
          this.paramsForStbApi['vendor-client-sid'] = 'pcg-next-gen-prototype-with-tass';
          break;
        case 'complispace':
          this.paramsForStbApi['vendor-client-sid'] = 'pcg-next-gen-prototype-with-complispace';
          break;
        case 'sentral-api':
          this.paramsForStbApi['vendor-client-sid'] = 'pcg-next-gen-prototype-with-sentral-api';
          break;
      }
      this.selectedClientSid =
        this.clientSids[this.paramsForStbApi['vendor-client-sid']][this.stbEnvironment];
      this.axiosInstanceForStbApi.defaults.params = this.paramsForStbApi;
      this.restartExcursion();
    },
    async testOauthSignature() {
      try {
        await this.$store.dispatch('stb-excursions/fetchExcursionTypes', {
          oauthSignature: this.oauthSignature,
          clientSid: this.selectedClientSid
        });
        this.isReadyToCreateExcursion = true;
      } catch (error) {
        this.showErrorAlert(error.message);
      }
    },
    onCompleteRiskAssessmentClicked() {
      this.clearAlert();
      this.isOnStbIframe = true;
    },
    changeStbEnvironment(stbEnvironment) {
      this.stbEnvironment = stbEnvironment;
      if (this.stbEnvironment === 'dev') {
        this.paramsForStbApi['vendor-sid'] = '10000415';
        this.axiosInstanceForStbApi.defaults.baseURL = 'https://api-dev.safetripbuilder.com/';
      } else if (this.stbEnvironment === 'staging') {
        this.paramsForStbApi['vendor-sid'] = '10000486';
        this.axiosInstanceForStbApi.defaults.baseURL = 'https://api-staging.safetripbuilder.com/';
      }
      this.selectedClientSid =
        this.clientSids[this.paramsForStbApi['vendor-client-sid']][this.stbEnvironment];
      this.axiosInstanceForStbApi.defaults.params = this.paramsForStbApi;
      this.restartExcursion();
    }
  }
};
</script>

<style scoped>
#stbRiskAssessmentContainer {
  border: 0;
  width: 100%;
  height: 100%;
}
.stb-risk-assessment-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: end;
}
</style>
